<style scoped lang="scss" type="text/scss">
    .confirm-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 1rem;

        .left-panel {
            width: 18rem;
            margin-right: 1rem;
        }

        .right-panel {
            flex: 1;
        }
    }
</style>

<template>
    <div class="confirm-wrap">
        <registrable-manged-player-selector></registrable-manged-player-selector>
        <div class="confirm-container">
            <left-panel class="left-panel"></left-panel>
            <card class="right-panel global-relative">
                <loading-placeholder :loading="requesting"></loading-placeholder>
                <router-view></router-view>
            </card>
            <count-down></count-down>
        </div>
    </div>
</template>

<script>
    import CountDown from '../../../sub-components/count-down/index';
    import LeftPanel from './left-panel';
    import Card from '../../../../components/card/index';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import {mapState} from 'vuex';

    export default {
        name: '',
        components: {
            LeftPanel,
            CountDown,
            Card,
            RegistrableMangedPlayerSelector
        },
        data () {
            return {
                requesting: false
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId
            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.$normalRequest('player/loadPlayerInfoPackage', {
                        id: this.currentManagedPlayerId
                    }, false, false, this, 'requesting').then();
                }
            }
        }
    };
</script>
